
import '../scss/main/theme.scss';

import invokeBootstrap from "./plugins/bootstrap";
import invokeKeenSlider from "./plugins/keen-slider";
import invokeLightbox from "./plugins/lightbox";
///@ts-ignore
// import invokeNavbar from "./plugins/navbar";
import invokeScrollTop from "./plugins/scroll-top";
import invokeTabs from "./plugins/tabs";
import invokeFade from "./plugins/fade";
import invokeBaffle from "./plugins/baffle";
import invokeIntersectionObserver from "./plugins/intersection-observer";
import invokeNav from "./plugins/nav";
import invokeHeroAnimation from "./plugins/hero-cursor-animation";

//Invoke NFCore Plugins
invokeBootstrap();
invokeKeenSlider();
invokeLightbox();
// invokeNavbar();
invokeScrollTop();
invokeTabs();
invokeFade();
invokeBaffle();
invokeIntersectionObserver();
invokeNav();
invokeHeroAnimation();
